import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router';
import { getOwnCourseMymesAPI, getOwnLocationBasedMymesAPI, getOwnTimeBasedMymesAPI } from '@myme/api';
import { publishMyme } from '@myme/logic';
import { UUID } from '@myme/utils';
import { useTranslation } from 'src/hooks';
import { mymeEditorFinishStepPageRoute } from 'src/routes/route-list';
import { toast, ToastType } from 'src/utils';

export const usePublishMymeMutation = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const publishMymeMutation = useMutation(
    async (_data: { mymeId: UUID; finishStep?: boolean }) => publishMyme(_data.mymeId),
    {
      onSuccess: (_res, data) => {
        if (data.finishStep) {
          navigate(mymeEditorFinishStepPageRoute(data.mymeId), { state: { finishStep: true } });
        }

        toast(ToastType.SUCCESS, t('pages.my_mymes.toast.publish_toast_success'));
        queryClient.refetchQueries(getOwnLocationBasedMymesAPI.cacheKeys);
        queryClient.refetchQueries(getOwnTimeBasedMymesAPI.cacheKeys);
        queryClient.refetchQueries(getOwnCourseMymesAPI.cacheKeys);
      }
    }
  );

  return { publishMymeMutation };
};
